import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn(
        // Pulse base + shimmer sweep for a livelier perceived-progress cue
        "relative overflow-hidden animate-pulse rounded-md bg-primary/10",
        "after:absolute after:inset-0 after:-translate-x-full after:animate-[shimmer_1.6s_infinite]",
        "after:bg-gradient-to-r after:from-transparent after:via-foreground/[0.06] after:to-transparent",
        "motion-reduce:after:hidden",
        className
      )}
      {...props} />
  );
}

export { Skeleton }
